
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tepezza/privacy-policy",
      function () {
        return require("private-next-pages/tepezza/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tepezza/privacy-policy"])
      });
    }
  